/**
 * The current signed-in user (GET /api/users/me).
 *
 * The token is the identity — no user id in the request. The backend
 * get-or-creates the User on first authenticated call; onboarding fills in the
 * parts Clerk doesn't give us (firstName/lastName/role) via PUT /api/users/me.
 */

import { apiGet } from '../apiClient';

export interface MeDto {
  id: string;
  memberId: string;
  organizationId: string;
  organizationName?: string | null;
  name?: string | null;
  firstName?: string | null;
  lastName?: string | null;
  role?: string | null;
  email: string;
  lastLogin?: string | null;
  createdAt: string;
}

/** GET /api/users/me — the authenticated user's profile. */
export function getMe(): Promise<MeDto> {
  return apiGet<MeDto>('/api/users/me');
}
